//////////////////////////////////////////////////////////////////////////////////////   IMPORT
///////////////////////////////////////////////////////////   SETTINGS
import { _SETTINGS } from 'config/settings';
//////////////////////////////////////////////////////////////////////////////////////    CLASS SETUP
export default function SpritePreset(player: any, options: any) {
  const url = options.url,
    height = options.height,
    width = options.width,
    responsive = options.responsive,
    controls = player.controlBar,
    progress = controls.progressControl,
    seekBar = progress.seekBar,
    mouseTimeDisplay = seekBar.mouseTimeDisplay;
  if (url && height && width && mouseTimeDisplay) {
    let img: any = document.getElementById('temporarityImg');
    img.src = url;
    let tooltipStyle = (obj: any) => {
      Object.keys(obj).forEach((key) => {
        let val = obj[key];
        let ttstyle = mouseTimeDisplay.timeTooltip.el().style;
        if (val !== '') {
          ttstyle.setProperty(key, val);
        } else {
          ttstyle.removeProperty(key);
        }
      });
    };
    const hijackMouseTooltip = async (isClicked: any) => {
      if (player) {
        if (player.currentWidth() && seekBar.currentWidth()) {
          mouseTimeDisplay.show();
          let timelineWidth = seekBar.currentWidth(),
            exactCurrentFrame = Math.floor(player.currentTime() * _SETTINGS.basic.frameRate),
            totalFrames = Math.floor(player.duration() * _SETTINGS.basic.frameRate),
            totalPercentage = 100 / (totalFrames / exactCurrentFrame);
          const imgWidth = img.naturalWidth,
            imgHeight = img.naturalHeight;
          if (player.controls() && imgWidth && imgHeight && seekBar && seekBar.currentWidth()) {
            let dotPos = (timelineWidth / 100) * totalPercentage,
              linePos = parseFloat(mouseTimeDisplay.el().style.left);
            if (isClicked) linePos = dotPos;
            linePos = player.duration() * (linePos / seekBar.currentWidth());
            if (!isNaN(linePos)) {
              linePos = Math.ceil(linePos / options.interval);
              const playerWidth = player.currentWidth(),
                scaleFactor = responsive && playerWidth < responsive ? playerWidth / responsive : 1,
                columns = imgWidth / width,
                scaledWidth = width * scaleFactor,
                scaledHeight = height * scaleFactor,
                bgSize = imgWidth * scaleFactor + 'px ' + imgHeight * scaleFactor + 'px';
              let cleft = Math.floor(linePos % columns) * -scaledWidth,
                ctop = Math.floor(linePos / columns) * -scaledHeight;
              const controlsTop = player.player_.children_[0].getBoundingClientRect(controls.el()).top,
                seekBarTop = player.player_.children_[0].getBoundingClientRect(seekBar.el()).top,
                topOffset = -scaledHeight - Math.max(0, seekBarTop - controlsTop);
              tooltipStyle({
                width: scaledWidth + 'px',
                height: scaledHeight + 'px',
                'background-image': 'url(' + url + ')',
                'background-repeat': 'no-repeat',
                'background-position-x': cleft - 1 + 'px ',
                'background-position-y': ctop + 'px',
                'background-size': bgSize,
                top: topOffset + 'px',
                color: '#fff',
                'background-color': 'rgba(0, 0, 0, 1)',
                'text-shadow': '1px 1px #000',
                border: '4px solid #fff',
                margin: '-45px 1px 0 1px'
              });
            }
          }
        }
      }
    };
    tooltipStyle({
      width: '',
      height: '',
      'background-image': '',
      'background-repeat': '',
      'background-position': '',
      'background-size': '',
      top: '',
      color: '',
      'text-shadow': '',
      border: '',
      margin: ''
    });
    let timer: any;
    controls.on('mousemove', () => {
      async function fvRepeater() {
        await hijackMouseTooltip(false);
        clearTimeout(timer);
        timer = setTimeout(mouseStopped, 275);
      }
      fvRepeater();
    });
    progress.on('click', () => hijackMouseTooltip(true));
    progress.on('touchmove', () => hijackMouseTooltip(false));
    player.addClass('vjs-sprite-thumbnails');
    progress.el().lastChild.onclick = () => {
      hijackMouseTooltip(true);
      mouseTimeDisplay.hide();
    };
    controls.on('click', () => mouseTimeDisplay.hide());
    const mouseStopped = () => {
      hijackMouseTooltip(false);
    };
  }
}
